import { CommonHeader, ContentArea } from "../../../components/commons";
import AddEditFixedAssetRegisterForm from "../../../components/FixedAssetRegister/AddEditFixedAssetRegisterForm";
import { UserIcon } from "../../../components/Icon";

type AppProps = {
  history: any;
};

const AddEditFixedAssetRegister = ({ history }: AppProps) => {
  let { pathname } = history?.location;

  const client_code = history?.location?.state?.client_code;
  const company_name =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.company_name
      ? history.location.state.company_name
      : "";
  return (
    <>
      <div className="col-md-4 mb-3">
        <CommonHeader
          title={`${pathname?.includes("add") ? "Add" : "Edit"}  Fixed Asset`}
        />
        <div className="d-flex align-items-center">
          {client_code ? (
            <>
              <UserIcon /> &nbsp;
              {company_name} {"(" + client_code + ")"}
            </>
          ) : null}
        </div>
      </div>

      <ContentArea>
        <AddEditFixedAssetRegisterForm history={history} />
      </ContentArea>
    </>
  );
};

export default AddEditFixedAssetRegister;
